module.exports = "## Compress Images\r\n\r\nWhile our image resizer allows basic image compression, you may want to use our advanced png and jpeg compressor to drastically reduce image size while retaining image quality. This editor allows you to reduce image size in Kb or Mb. Simply select “Custom File Size” option and enter your target file size. \r\n"


//////////////////
// WEBPACK FOOTER
// ./src/containers/ImageResize/compress-images.md
// module id = 1174
// module chunks = 0